import React from 'react';
import { Auth0Provider } from "@auth0/auth0-react";
import styled, { ThemeProvider } from 'styled-components';
import { UserProfile } from '../containers/UserProfile';
import { PageComponent } from '../containers/PageComponent';
import { theme } from '../constants';

const Layout = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background};;
  height: 100vh;
  padding: 44px;
  font-family: 'Helvetica', sans-serif;
  font-size: 10px;
`;

interface Props {
  name: string;
  age: number;
}

const Page: React.FC<Props> = ({ name = '', age = 0 }) => {
  return (
    //   <Auth0Provider
    //     // audience='api.yotpo.com'
    //     domain="auth.yotpo.com"
    //     clientId="V6RT7uQKK99dfOM9ao67xqEjulZkn2tK"
    //     authorizationParams={{
    //       redirect_uri: window.location.origin
    //     }}
    //   >
        <ThemeProvider theme={theme}>
            <UserProfile>
            <Layout>
                <PageComponent name={''} description={''} />
            </Layout>
            </UserProfile>
        </ThemeProvider>
    //   </Auth0Provider>
  );
};

export default Page;
